import { useQueryApi } from 'utils/api'
import { apiPaths } from 'api/kinerja/kepala-sekolah/config'

import type { PengawasProfile } from 'types/kinerja-ks'
import type { CommonResponse } from 'types/api'
import type { UseQueryOptions } from 'react-query'

export const API_GET_PS_PROFILE_QUERY_KEY = 'API_GET_PS_PROFILE_QUERY_KEY'

type ProfileResponse = CommonResponse<PengawasProfile>

export function useApiGetPsProfile(opts?: UseQueryOptions<ProfileResponse>) {
  return useQueryApi<ProfileResponse>(`${apiPaths.pengawasSekolah}/profile`, {
    queryKey: API_GET_PS_PROFILE_QUERY_KEY,
    queryConfig: {
      useErrorBoundary: false,
      staleTime: 60 * 60 * 1000, // 1 hour
      ...opts,
    },
  })
}
